import { module } from 'modujs';
import LazyLoad from "vanilla-lazyload";

export default class extends module {
    constructor(m) {
        super(m);
        axios.get( THEME_OBJ.ajaxURL + '?action=page_header_ctas').then( (response) => {
            this.el.innerHTML = response.data + this.el.innerHTML;
            this.call( 'update', this.el, 'app' );
            /*
            this.el.classList.remove( 'loading' );
            this.el.classList.toggle( 'hidden', this.page === this.maxNumPages );
            new LazyLoad({ elements_selector : '[data-scroll-call="toggleLazy,Scroll"]', container: document.querySelector( this.el.dataset.target ) });
            this.call('update', false, 'Scroll');
            //this.call('scrollTo', { target : this.target, options: { offset: -150 } },  'Scroll');*/
        });
    }
    init() {}
    destroy(){}
}
